import { Serializable } from "../utilities/Serializable";

export class Organization extends Serializable {
    uuid: string;
    companyName: string;
    vatRegistration: string;
    legalAddress: string;
    fieldOffice: string;
    cardBalanceLimit: number;

    constructor() {
        super();
    }
}



// WEBPACK FOOTER //
// ./src/app/models/Organization.ts